import {down, up} from 'styled-breakpoints';
import styled, {css} from 'styled-components';

import {Button} from '@ui/atoms/button';
import {getColorFromTheme} from '@ui/ui-utils';

export const OuterWrapper = styled.form``;

export const DelimitingWrapper = styled.div``;

export const TagWrapper = styled.div`
  padding: 4px 8px;
  border-radius: 8px;
  background: #f6f6f8;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #5f5f8c;
  display: flex;
  align-items: center;
  svg {
    width: 14px;
    height: 14px;
    margin-left: 6px;
    path {
      fill: black;
    }
  }
`;
export const ButtonWrapper = styled.div``;

export const SubmissionActionButton = styled(Button)`
  &:disabled[aria-busy='false'] {
    border-color: ${getColorFromTheme('backgroundDark')};
    background-color: ${getColorFromTheme('backgroundDark')};
    color: ${getColorFromTheme('textMuted')};
  }
`;

export const SubmissionMeta = styled.section`
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
  padding: 24px;
`;

export const SubmissionMetaTop = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;

  ${down('sm')} {
    align-items: flex-start;
    flex-direction: column;
  }
`;

export const SubmissionMetaDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const SubmissionSender = styled.p`
  color: ${getColorFromTheme('textBody')};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
`;

export const SubmissionSentDate = styled(SubmissionSender)``;

export const SubmissionMetaActions = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const SubmissionProgressRow = styled.div`
  align-items: center;
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1fr) auto;
`;

export const SubmissionProgressTrack = styled.div`
  background: ${getColorFromTheme('borderLight')};
  border-radius: 999px;
  height: 4px;
  overflow: hidden;
  width: 100%;

  span {
    background: ${getColorFromTheme('purple300')};
    border-radius: inherit;
    display: block;
    height: 100%;
    min-width: 4px;
    transition: width 180ms ease;
  }
`;

export const SubmissionProgressLabel = styled.p`
  color: ${getColorFromTheme('blackTwo')};
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  white-space: nowrap;
`;

export const SubmissionBlock = styled.section<{$completed?: boolean}>`
  background: ${getColorFromTheme('white')};
  border: 1px solid
    ${({$completed}) =>
      $completed
        ? getColorFromTheme('purple300')
        : getColorFromTheme('borderLight')};
  border-radius: 10px;
  overflow: hidden;
  transition: border-color 160ms ease;
`;

export const SubmissionBlockHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 24px 12px;
`;

export const SubmissionBlockTitle = styled.div`
  color: ${getColorFromTheme('blackTwo')};
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;

  .required {
    color: ${getColorFromTheme('red400')};
  }
`;

export const SubmissionBlockSubtitle = styled.p`
  color: ${getColorFromTheme('textBody')};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: -4px 0 0;
`;

export const SubmissionBlockContent = styled.div`
  padding: 0 24px 24px;
`;

export const SubmissionTypeTag = styled.span<{
  $type: 'question' | 'pulse' | 'checklist' | 'goals';
}>`
  align-items: center;
  align-self: flex-start;
  background: ${({$type}) =>
    $type === 'pulse'
      ? getColorFromTheme('orange100')
      : $type === 'checklist'
      ? getColorFromTheme('blue100')
      : $type === 'goals'
      ? getColorFromTheme('purple100')
      : getColorFromTheme('green100')};
  border-radius: 999px;
  color: ${({$type}) =>
    $type === 'pulse'
      ? getColorFromTheme('orange300')
      : $type === 'checklist'
      ? getColorFromTheme('blue300')
      : $type === 'goals'
      ? getColorFromTheme('purple300')
      : getColorFromTheme('green300')};
  display: inline-flex;
  font-size: 11px;
  font-weight: 500;
  line-height: 18px;
  padding: 3px 10px;
`;

export const TodoCard = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  min-width: 0;
`;

export const TodoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &:first-child {
    border-top: none;
    padding-top: 0;
  }
`;

export const TodoSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const TodoList = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  overflow: hidden;
  width: 100%;
`;

export const TodoRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 120px 160px 122px;
  align-items: center;
  gap: 0;
  min-height: 70px;
  padding: 0;
  border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  box-sizing: border-box;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 1080px) {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px 16px;
    padding: 16px;
    min-height: auto;
  }

  ${down('md')} {
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px 16px;
    padding: 16px;
    min-height: auto;
  }

  ${down('sm')} {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
`;

export const TodoRowBody = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 16px;

  @media (max-width: 1080px) {
    grid-column: 1;
    grid-row: 1;
    padding: 0;
  }
`;

export const TodoTitle = styled.p`
  color: ${getColorFromTheme('blackTwo')};
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TodoMeta = styled.p`
  color: ${getColorFromTheme('textBody')};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TodoSentDate = styled.p`
  color: ${getColorFromTheme('textBody')};
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  text-align: center;
  white-space: nowrap;

  ${down('md')} {
    text-align: left;
  }
`;

export const TodoSentDateCell = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  min-width: 0;
  padding: 16px;

  @media (max-width: 1080px) {
    grid-column: 1;
    grid-row: 2;
    justify-content: flex-start;
    padding: 0;
  }
`;

export const TodoDateCell = styled.div`
  align-items: center;
  display: flex;
  min-width: 0;
  padding: 16px;

  @media (max-width: 1080px) {
    grid-column: 1;
    grid-row: 3;
    padding: 0;
  }
`;

export const TodoStatus = styled.span<{
  variant?: 'warning' | 'danger' | 'info' | 'neutral';
  hiddenState?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 12px;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid #cecede;
  color: ${({variant}) =>
    variant === 'danger'
      ? '#D52A2A'
      : variant === 'info'
      ? '#5F5F8C'
      : variant === 'warning'
      ? '#E87F16'
      : '#5F5F8C'};
  visibility: ${({hiddenState}) => (hiddenState ? 'hidden' : 'visible')};
  border-color: ${({hiddenState}) => (hiddenState ? 'transparent' : '#cecede')};
`;

export const CheckinStatusBadge = styled.div<{
  variant?: 'warning' | 'danger' | 'info' | 'neutral';
}>`
  align-items: center;
  background: ${getColorFromTheme('white')};
  border: 1px solid ${getColorFromTheme('borderDark')};
  border-radius: 8px;
  box-sizing: border-box;
  color: ${getColorFromTheme('textBody')};
  display: inline-flex;
  flex-wrap: wrap;
  font-size: 12px;
  font-weight: 500;
  gap: 2px 8px;
  justify-content: center;
  justify-self: start;
  line-height: 20px;
  min-height: 38px;
  padding: 8px 16px;
  text-align: center;
  white-space: normal;
  width: 128px;

  .due-state {
    color: ${({variant}) =>
      variant === 'danger'
        ? getColorFromTheme('red400')
        : variant === 'warning'
        ? getColorFromTheme('orange300')
        : getColorFromTheme('textBody')};
  }

  ${down('md')} {
    grid-column: 1;
  }
`;

export const TodoAction = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  width: auto;
  padding: 16px;

  button {
    min-height: 38px;
    white-space: nowrap;
  }

  svg {
    height: 16px;
    width: 16px;

    path {
      stroke: ${getColorFromTheme('textDark')};
    }
  }

  @media (max-width: 1080px) {
    align-self: center;
    grid-column: 2;
    grid-row: 1 / span 3;
    justify-content: flex-end;
    padding: 0;
  }

  ${down('md')} {
    grid-column: 2;
    grid-row: 1 / span 3;
    align-self: center;
  }

  ${down('sm')} {
    width: 100%;

    button {
      width: 100%;
    }
  }
`;

export const TodoCountBadge = styled.span`
  align-items: center;
  background: ${getColorFromTheme('red400')};
  border-radius: 999px;
  color: ${getColorFromTheme('alwaysWhite')};
  display: inline-flex;
  font-size: 11px;
  font-weight: 600;
  height: 16px;
  justify-content: center;
  line-height: 16px;
  min-width: 16px;
  padding: 0 4px;
`;

export const TodoEmptyState = styled.div`
  padding: 16px 0;
  min-height: 56px;
  color: #5f5f8c;
`;

export const Wrapper = styled.div`
  ${down('sm')} {
    margin-bottom: 10px;
  }

  ${up('sm')} {
    margin-bottom: 20px;
  }

  ${up('lg')} {
    margin-bottom: 40px;
  }

  ${up('xl')} {
    margin-bottom: 40px;
  }
`;

export const FormGrid = styled.div<{showHistory?: boolean}>`
  display: grid;
  gap: 24px;
  grid-template-columns: 1fr;
  ${up('lg')} {
    grid-template-columns: ${({showHistory}) =>
      showHistory ? 'repeat(2, minmax(0, 1fr))' : '1fr'};
  }
`;

export const FormContainer = styled.div<{showHistory?: boolean}>`
  width: 100%;
  margin: 0 auto;
  max-width: ${({showHistory}) => (showHistory ? '100%' : '720px')};
  transition: max-width 0.2s ease;
  position: relative;

  ${({showHistory}) =>
    showHistory &&
    css`
      width: 100vw;
      margin-left: calc(50% - 50vw);
      margin-right: calc(50% - 50vw);

      &::after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        width: 1px;
        background: ${getColorFromTheme('borderLight')};
        left: 50%;
        transform: translateX(-0.5px);
        pointer-events: none;
      }
    `}
`;

export const GridItem = styled.div<{dividerSide?: 'left' | 'right'}>`
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 40px;
  padding-top: 40px;
`;

export const HistoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HistoryListItem = styled.li`
  border: 1px solid #ededf2;

  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HistoryEntryMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const HistoryHighlights = styled.ul`
  margin: 0;
  padding-inline-start: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ChecklistRemoveButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HorizontalHr = styled.div`
  border: 1px solid #ededf2;
  opacity: 0.5;
`;
export const MoodDiv = styled.div<{
  activated?: boolean;
  disabled?: boolean;
  error?: boolean;
}>`
  border-radius: 10px;
  div.contentDiv {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 16px;
    border: 1px solid;
    border-color: ${({error}) =>
      error ? getColorFromTheme('red400') : getColorFromTheme('borderLight')};
    border-radius: 10px;

    ${down('sm')} {
      padding: 16px 12px;
    }
    .inner-content {
      width: 82%;
      ${down('lg')} {
        width: 90%;
      }
      ${down('md')} {
        width: 100%;
      }
      display: flex;
      justify-content: space-between;
      align-items: center;

      .emoji {
        background: transparent;
        border: 0;
        color: inherit;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        gap: 4px;
        padding: 0;

        .halo {
          display: inline-flex;
          padding: 4px;
          border-radius: 50%;

          &:hover {
            background: ${({disabled}) =>
              disabled ? '' : getColorFromTheme('purple300')};
          }

          .img {
            width: 56px;
            height: 56px;
            ${down('sm')} {
              width: 46px;
              height: 46px;
            }
            img {
              width: 56px;
              height: 56px;
              ${down('sm')} {
                width: 46px;
                height: 46px;
              }
            }
          }
        }

        &:focus-visible {
          outline: 2px solid ${getColorFromTheme('purple300')};
          outline-offset: 4px;
          border-radius: 8px;
        }

        &:disabled {
          cursor: default;
        }
      }
    }
    .second-inner-content {
      width: 58.8%;
      margin-top: 24px;
      ${down('md')} {
        width: 100%;
      }
    }
  }
`;

export const ProgressDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  div.titleDiv {
    padding: 18px 24px 16px;
  }
  div.contentDiv {
    padding: 8px 8px 0 8px;
    border-radius: 10px 10px 0px 0px;
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }
`;

export const PrioritiesDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  div.titleDiv {
    padding: 18px 24px 16px;
  }
  div.contentDiv {
    padding: 16px 8px 8px 0px;
    border-radius: 10px 10px 0px 0px;
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }
`;

export const WorkLifeDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  div.headerDiv {
    padding: 18px 24px 16px;
  }
  div.titleDiv {
    display: flex;
    justify-content: space-between;
  }
  div.contentDiv {
    padding: 24px;
    border-radius: 10px 10px 0px 0px;
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }
`;

export const FeedbackDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  div.titleDiv {
    padding: 18px 24px 16px;
  }
  div.contentDiv {
    padding: 24px;
    border-radius: 10px 10px 0px 0px;
    border-top: 1px solid ${getColorFromTheme('borderLight')};
  }
`;
export const ItemLoaderWrapper = styled.div`
  padding: 28px 12px 32px 22px;
  justify-content: center;
  width: 100%;
`;

export const ReviewerBox = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  .title-div {
    padding: 16px 16px 8px;
  }
  .content-div {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border-top: 1px solid ${getColorFromTheme('borderLight')};
    padding-top: 32px;
    padding-bottom: 56px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
`;
export const EmptyPlaceholderWrapper = styled.div`
  border: 1px solid #ededf2;
  margin-left: 20px;
  width: 98%;
  height: 600px;
  border-radius: 10px;
`;
export const ReviewerBoxMobile = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  display: grid;
  padding: 8px;
  grid-template-columns: 40% 60%;
  align-items: center;
  .title {
    display: flex;
    align-items: center;
  }
  .content-div {
    display: flex;

    align-items: center;
    justify-content: center;
    .content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }
  }
`;

export const MobileWrapper = styled.div`
  display: none;
  ${down('md')} {
    display: block;
  }
`;

export const EmptyDiv = styled.div`
  border: 1px solid #ededf2;
  border-radius: 10px;
`;
export const CommentNotif = styled.div`
  position: relative;

  .dot {
    position: absolute;
    bottom: 16px;
    right: -5%;
  }
`;
